module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    style: (_vm.position),
    attrs: {
      "id": "quc-login-pane"
    }
  }, [_c('i', {
    staticClass: "arrow"
  }), _c('div', {
    ref: "injector",
    staticClass: "quc-wrapper quc-page"
  }), _c('div', {
    staticClass: "divider"
  }), _vm._m(0), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "dj-tip"
  }, [_vm._v("如果您是"), _c('b', [_vm._v("有效的点睛客户")]), _vm._v("，可直接用点睛帐号登录360分析，直接开通无需重新注册。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "newuser",
    attrs: {
      "href": "http://i.360.cn/reg?destUrl=http://fenxi.businessdata.360.cn/"
    }
  }, [_vm._v("新用户，立即注册")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-16bceb4a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-16bceb4a!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/login.vue
// module id = 716
// module chunks = 0